import Nzh from "nzh";

const locales = {
  arabic: 'ar',
  chinese: 'zh-cn',
  english: 'en',
  french: 'fr',
  german: 'de-de',
  spanish: 'es-mx',
};

const localesWithCountry = {
  [locales.arabic]: 'ar-eg',
  [locales.chinese]: 'zh-cn',
  [locales.english]: 'en-us',
  [locales.french]: 'fr-fr',
  [locales.german]: 'de-de',
  [locales.spanish]: 'es-mx',
};

const numbersInWords = {
  [locales.arabic]: [
    'صفر', 'واحد', 'اثنان', 'ثلاثة', 'أربعة', 'خمسة', 'ستة', 'سبعة', 'ثمانية', 'تسعة', 'عشرة',
    'أحد عشر', 'اثنا عشر', 'ثلاثة عشر', 'أربعة عشر', 'خمسة عشر', 'ستة عشر', 'سبعة عشر', 'ثمانية عشر', 'تسعة عشر', 'عشرون',
  ],
  [locales.chinese]: [
    '零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
    '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十',
  ],
  [locales.english]: [
    'zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
    'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen', 'twenty',
  ],
  [locales.french]: [
    'zéro', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix',
    'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize', 'dix-sept', 'dix-huit', 'dix-neuf', 'vingt',
  ],
  [locales.german]: [
    'null', 'ein', 'zwei', 'drei', 'vier', 'fünf', 'sechs', 'sieben', 'acht', 'neun', 'zehn',
    'elf', 'zwölf', 'dreizehn', 'vierzehn', 'fünfzehn', 'sechzehn', 'siebzehn', 'achtzehn', 'neunzehn', 'zwanzig',
  ],
  [locales.spanish]: [
    'cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez',
    'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve', 'veinte',
  ],
};

function getGermanFomattedDate(dateObj) {
  const parts = new Intl.DateTimeFormat(
    localesWithCountry[locales.german],
    { year: 'numeric', month: 'long', day: 'numeric' },
  ).formatToParts(dateObj);

  const dateParts = {};
  for (let i = 0; i < parts.length; i++) {
    dateParts[parts[i].type] = parts[i].value;
  }

  return `${dateParts.year} ${dateParts.month} ${dateParts.day}`;
}

export function getLocalizedFomattedDate(date, locale = locales.english) {
  const dateObj = new Date(date);
  let formattedDate = '';

  switch (locale) {
    case locales.german:
      formattedDate = getGermanFomattedDate(dateObj);
      break;
    default:
      formattedDate = dateObj.toLocaleDateString(
        localesWithCountry[locale],
        { year: 'numeric', month: 'long', day: 'numeric' },
      );
  }
  return formattedDate;
}

export function getLocalizedFormattedNumber(number, locale = locales.english, inWords = false) {
  const inWordsLimit = numbersInWords[locale].length;
  if (inWords && number >= 0 && number < inWordsLimit) {
    return numbersInWords[locale][number];
  }

  let formattedNumber;
  switch (locale) {
    case locales.chinese:
      formattedNumber = Nzh.cn.encodeS(number);
      break;
    default:
      formattedNumber = Intl.NumberFormat(localesWithCountry[locale]).format(number);
  }
  return formattedNumber;
}
